export default __webpack_public_path__ + "static/media/meatgrinder.bd794472.jpg";